import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonIcon, IonInput, IonModal, IonProgressBar, IonSelect, IonSelectOption, IonSpinner, IonTextarea } from '@ionic/react';
import { useHistory } from 'react-router-dom';
import { appConfig } from './domain/Config';
import { duplicate, mailOutline } from 'ionicons/icons';
import useAuth from './domain/Auth';
import GlobalContext from './domain/GlobalContext';
import { useCallback, useContext, useEffect, useState } from 'react';
import { api } from "./domain/ApiService";
import ListView from './components/ListView';
import { Initiative } from './domain/Types';
import CreateInitiative from './components/CreateInitiative';
import { v4 as uuidv4 } from 'uuid';

const Home: React.FC = () => {

  const history = useHistory();

  const { user, initiatives, initiative, setInitiative, isDarkMode, setIsDarkMode, isMenuVisible, setIsMenuVisible, smallScreen } = useContext(GlobalContext);
  const [filteredInitiatives, setFilteredInitiatives] = useState<Initiative[]>([]);
  const [templates, setTemplates] = useState<Initiative[]>([]);
  const [clickedTemplate, setClickedTemplate] = useState<Initiative>();
  const [showCreateInitiativeModal, setShowCreateInitiativeModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const [ template, setTemplate ] = useState<Initiative | null>(null);

  useEffect(() => {

    if (initiatives != null) {

      setTemplates(initiatives.filter(initiative => {
        return initiative.template ? initiative.template : false;
      }).reverse());

      let filtered = initiatives.filter(initiative => {
        if (user?.auth_id && initiative && !initiative.template) {

            const isOwnerOrCollaborator = !initiative.owners || !initiative.collaborators || initiative.owners.includes(user.auth_id) || initiative.collaborators.includes(user.auth_id);
            const isCollaboratorOrAllUsers = !initiative.collaborators || initiative.collaborators.includes(user.auth_id) || initiative.collaborators.length === 0 || initiative.collaborators.includes("allUsers");
            return isOwnerOrCollaborator || isCollaboratorOrAllUsers;
        }
        return false;
      });

      setFilteredInitiatives(filtered.reverse());
    }

  }, [initiatives]);
    
  const handleClick = (clickedInitiative: Initiative) => {

    setInitiative(clickedInitiative);
    window.dispatchEvent(new Event('initiativeChange'));
    setHasNavigated(false);
  };

  const handleTemplateClick = (clickedInitiative: Initiative) => {

    setClickedTemplate(clickedInitiative);
    setShowCreateInitiativeModal(true);
  };

  const handleEdit = (clickedInitiative: Initiative | null) => {

    // if (clickedInitiative)
    //   alert("move to initiative settings")
    // else
      setShowCreateInitiativeModal(true);
  };

  const handleEditTemplate = (clickedInitiative: Initiative | null) => {

    if (clickedInitiative == null) {

      let newTemplate = { 
        uid: uuidv4(),
        initiative_type: appConfig.initiativeTypes[0], 
        routes: { assistants: [] }, 
        template: true,
        name: "",
        slug: "",
        instructions: "" 
      };

      setTemplate(newTemplate);
      setShowModal(true);
    }
    else {

      setInitiative(clickedInitiative);
      setHasNavigated(false);
      setShowModal(false);
    }    
  };

  const handleCancel = () => {

    setShowModal(false);
    setTemplate(null);
  };

  const handleCreateInitiative = useCallback(async (generate: boolean) => {

    if (template?.description == null || template?.description.trim() == "") {

      return;
    }

    if (setInitiative == null || template == null) return;
    setLoadingModal(true);

    let iType = template?.initiative_type;

    if (iType == null || iType.trim() == "") {
        iType = appConfig.initiativeTypes[0];
    }

    if (generate) {

        const createdInitiative: Initiative = await api('/initiative/generate', {"description": template?.description }, initiative);        
        setInitiative(createdInitiative);
        setHasNavigated(false);
      }
    else {

        let newInitiative = { 
            template: true,
            initiative_type: iType, 
            routes: { assistants: [] }, 
            instructions: template.instructions 
        };

        const createdInitiative: Initiative = await api('/initiative/create', newInitiative, initiative);        
        setInitiative(createdInitiative);
        setHasNavigated(false);
    }

    setShowModal(false);
    setLoadingModal(false);

    window.dispatchEvent(new Event('initiativeChange'));
    window.dispatchEvent(new Event('initiativeCreated'));

  }, [template, initiative, setInitiative, history]);
    
  const [hasNavigated, setHasNavigated] = useState(true);
  useEffect(() => {
      if (initiative && initiative.slug && !hasNavigated) {

        if (initiative.template || !initiative.assistants || initiative.assistants.length === 0)
          history.push("/" + initiative.slug +"/settings");
        else
          history.push("/" + initiative.slug);
        
        setHasNavigated(true);
      }
  }, [initiative, history, hasNavigated]);  

  const handleClose = () => {

    setClickedTemplate(undefined);
    setShowCreateInitiativeModal(false);
  };

  return (

    <>
    {initiatives != null ?
    <>
      <IonCard className='filled' style={{ padding: "10px" }}>        
        <IonCardHeader>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
            <IonCardTitle style={{ textAlign: 'left' }}>Create new</IonCardTitle>
            <IonButton className='basic' onClick={() => window.location.href = '/store'}>Discover more ...</IonButton>
          </div>
        </IonCardHeader>
          <IonCardContent>
          <ListView<Initiative>
              items={templates}
              columns={[
                { attribute: 'image', label: 'Image', isImage: true, size: "small" },
                { attribute: 'deliverable', label: 'Deliverable', size: "small", primary: true },
                { attribute: 'name', label: 'Launchpad', size: "small" },
                { attribute: 'description', label: 'Description', size: "small" }
              ]}
              onClick={handleTemplateClick}
              buttonLabel="create_action"
              enableReorder={false}
              defaultLayout={'cards'}
              showActions={user?.role == 'admin' ? true : false}
              showHeaderActions={false}
              onEdit={user?.account?.plan == "business" || user?.account?.plan == "creator" ? handleEditTemplate : undefined}       
              addMore={user?.account?.plan == "business" || user?.account?.plan == "creator" ? true : false}
              addMoreLabel={user?.account?.plan == "business" || user?.account?.plan == "creator" ? "New launchpad" : undefined}             
            />

          <IonModal className="form-modal" onDidDismiss={() => setShowModal(false)} isOpen={showModal}>
            {(!loadingModal && template) ? 
                <div className="form">

                  <big>Customize your own launchpad</big>
                  <div style={{ marginTop: "10px", marginBottom: "15px" }}>
                  A launchpad is a smart template powered by AI assistants.
                  It guides you through a focused flow to create a specific deliverable - like a proposal, article, or plan.
                  </div>

                    <IonTextarea 
                        className='form-element'
                        label="What would you like to create?"
                        labelPlacement="floating"
                        fill="outline"
                        rows={5}            
                        value={template.description}
                        onIonChange={e => template.description = e.detail.value!} 
                        placeholder="Example: I want to create blog posts for my software development agency. We focus on AI solutions and enterprise workflow automation. Each post should include a intro, the main content, headline veriations, and images."
                    />                    
                    {(appConfig.initiativeTypes.length !== 1 || appConfig.initiativeTypes[0] !== 'client') ? 
                    <>
                      <IonButton onClick={() => handleCreateInitiative(true)}>Create a launchpad</IonButton>
                    </>
                    : 
                    <IonButton onClick={() => handleCreateInitiative(false)}>Create template</IonButton>
                    }


                    <IonButton className="basic" onClick={handleCancel}>Cancel</IonButton>

                </div>
            :
                <div className="form" style={ { minHeight: "160px" } }>
                <div className="form-element-title" style={{ opacity: "0.5", width: "100%", textAlign: "center" }}>                  
                    <IonIcon icon={ duplicate } style={{ width: "60px", height: "60px" }} className="menu" color={ "medium" } />            
                </div>
                <div className="form-element-title" style={{ opacity: "0.5", width: "100%", textAlign: "center" }}>
                    Preparing ...
                </div>
                <div className="form-element-title" style={{ width: "100%", textAlign: "center" }}>
                    <IonSpinner name="dots" color="dark" class="large-spinner" style={{margin: "10px"}}></IonSpinner>
                </div>
                </div>
            }
            </IonModal>


        </IonCardContent>
      </IonCard>
      {filteredInitiatives.length > 0 &&      
      <IonCard className='filled' style={{ padding: "10px" }}>
        <IonCardHeader>
          <IonCardTitle>Recently created</IonCardTitle>
        </IonCardHeader>
        <IonCardContent>
          <ListView<Initiative>
              items={filteredInitiatives}
              columns={[
                { attribute: 'image', label: 'Image', isImage: true, size: "small" },
                { attribute: 'deliverable', label: 'Deliverable', size: "small" },
                { attribute: 'name', label: 'Name', size: "small", primary: true },
                { attribute: 'description', label: 'Description', size: "medium" },
              ]}
              onEdit={handleEdit}                    
              onClick={handleClick}
              enableReorder={false}
              defaultLayout={'table'}
              showActions={false}
              showHeader={false}
              addMore={true}
              buttonLabel="Add more"
              />
        </IonCardContent>
      </IonCard>
      }
      <CreateInitiative
        show={showCreateInitiativeModal}
        onClose={handleClose}
        forTemplateId={clickedTemplate?.id}
      />
    </>
    :
      <IonProgressBar type="indeterminate" color="medium"></IonProgressBar>
    }
    </>

  );
};

export default Home;